import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Observable } from 'rxjs';
import { User } from '../_models/user';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  constructor(private http: HttpClient) {}

  baseUrl = environment.apiUrl;

  jwtHelper = new JwtHelperService();

  getToken() {
    const token = localStorage.getItem('token');
    return token;
  }

  getUserByEmail(email) {
    return this.http.get(this.baseUrl + `user/GetUserDetail?email=${email}`);
  }

  // return all top authorities, without any filtering
  getAllTopAuthorities() {
    return this.http.get(this.baseUrl + `user/AllTopAuthorityNames`);
  }

  getAuthorityNames() {
    let tokenString = '';
    const securityToken: string = localStorage.getItem('token');
    let httpHeaders = new HttpHeaders();
    if (securityToken != null) {
      tokenString = `Bearer ${securityToken}`;
      httpHeaders = new HttpHeaders()
        .set('authorization', tokenString)
        .set('Content-Type', 'application/json');
    } else {
      httpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json');
    }
    return this.http.get(this.baseUrl + `user/TopAuthorityNames`, {headers: httpHeaders});
  }

  getLevel1AuthorityNames() {
    return this.http.get(this.baseUrl + `user/Level1AuthorityNames`);
  }
  getLevel2AuthorityNames() {
    return this.http.get(this.baseUrl + `user/Level2AuthorityNames`);
  }
  getLevel3AuthorityNames() {
    return this.http.get(this.baseUrl + `user/Level3AuthorityNames`);
  }

// gets all users by Authority
  getAllUsersByAuthority(model: any) {
    let tokenString = '';
  const securityToken: string = localStorage.getItem('token');
  let httpHeaders = new HttpHeaders();
  if (securityToken != null) {
    tokenString = `Bearer ${securityToken}`;
    httpHeaders = new HttpHeaders()
      .set('authorization', tokenString)
      .set('Content-Type', 'application/json');
  } else {
    httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json');
  }
    return this.http.post(this.baseUrl + `user/GetAllUsers`, model, {headers: httpHeaders, observe: 'response'});
  }

  getUser(id: string): Observable<User> {
    let tokenString = '';
    const securityToken: string = localStorage.getItem('token');
    let httpHeaders = new HttpHeaders();
    if (securityToken != null) {
      tokenString = `Bearer ${securityToken}`;
      httpHeaders = new HttpHeaders()
        .set('authorization', tokenString)
        .set('Content-Type', 'application/json');
    } else {
      httpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json');
    }
    return this.http.get<User>(this.baseUrl + 'user/GetSDSUser/' + id, {headers: httpHeaders});
  }

// update sds user
  updateUserInfo(id: string, user: any) {
    let tokenString = '';
    const securityToken: string = localStorage.getItem('token');
    let httpHeaders = new HttpHeaders();
    if (securityToken != null) {
      tokenString = `Bearer ${securityToken}`;
      httpHeaders = new HttpHeaders()
        .set('authorization', tokenString)
        .set('Content-Type', 'application/json');
    } else {
      httpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json');
    }
    return this.http.put(this.baseUrl + 'user/' + id, user, {headers: httpHeaders, observe: 'response'});
  }

 // update identity user
  updateIdentityPassword(user: any){
    return this.http.post(this.baseUrl + 'user/UpdatePassword/' , user, {observe: 'response'});
  }

  inviteUserBySiteAdmin(model: any) {
    let tokenString = '';
    const securityToken: string = localStorage.getItem('token');
    let httpHeaders = new HttpHeaders();
    if (securityToken != null) {
      tokenString = `Bearer ${securityToken}`;
      httpHeaders = new HttpHeaders()
        .set('authorization', tokenString)
        .set('Content-Type', 'application/json');
    } else {
      httpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json');
    }
    return this.http.post(this.baseUrl + `user/invite`, model, {headers: httpHeaders, observe: 'response'});
  }

  assignUserLocation(l: any){
    // console.log(model);
    return this.http.post(this.baseUrl + `user/assign?${l}`,  l, {observe: 'response'});
  }

  completeInviteeRegistration(model: any) {
    return this.http.post(this.baseUrl + `account/InviteeConfirmed`, model, {observe: 'response'});
  }

  getUserByOutSideId(id: string){
    return this.http.get(this.baseUrl + `user/getUserByOutSideId/` + id);
  }

  //returns the user object
  getIdentityUser(id: string){
    return this.http.get(this.baseUrl + 'user/GetIdentityUser/' + id);
  }

  // creates internal user
  createInternalUser(model: any) {
    let tokenString = '';
    const securityToken: string = localStorage.getItem('token');
    let httpHeaders = new HttpHeaders();
    if (securityToken != null) {
      tokenString = `Bearer ${securityToken}`;
      httpHeaders = new HttpHeaders()
        .set('authorization', tokenString)
        .set('Content-Type', 'application/json');
    } else {
      httpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json');
    }
    return this.http.post(this.baseUrl + 'user/CreateInternalUser', model, {headers: httpHeaders, observe: 'response'});
  }

  getUserId() {
    return this.http.get(this.baseUrl + 'user/getUserId');
  }

  resendUserEmail(email: string) {
    let tokenString = '';
    const securityToken: string = localStorage.getItem('token');
    let httpHeaders = new HttpHeaders();
    if (securityToken != null) {
      tokenString = `Bearer ${securityToken}`;
      httpHeaders = new HttpHeaders()
        .set('authorization', tokenString)
        .set('Content-Type', 'application/json');
    } else {
      httpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json');
    }
    return this.http.post(this.baseUrl + `user/ResendUserEmail/${email}`, email, {headers: httpHeaders, observe: 'response'});
  }

  levelDropDown(id: number) {
    return this.http.get(this.baseUrl + 'Site/levelDropDown/' + id);
  }

  getAllUserLocationNames(id: number){
    return this.http.get(this.baseUrl + 'user/getAllUserLocationNames/' + id);
  }

  removeUser(id: number) {
    let tokenString = '';
    const securityToken: string = localStorage.getItem('token');
    let httpHeaders = new HttpHeaders();
    if (securityToken != null) {
      tokenString = `Bearer ${securityToken}`;
      httpHeaders = new HttpHeaders()
        .set('authorization', tokenString)
        .set('Content-Type', 'application/json');
    } else {
      httpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json');
    }    return this.http.delete(this.baseUrl + 'user/deleteUser/' + id, {headers: httpHeaders, observe: 'response'});
  }

  getUserLocation(id: string) {
    let tokenString = '';
    const securityToken: string = localStorage.getItem('token');
    let httpHeaders = new HttpHeaders();
    if (securityToken != null) {
      tokenString = `Bearer ${securityToken}`;
      httpHeaders = new HttpHeaders()
        .set('authorization', tokenString)
        .set('Content-Type', 'application/json');
    } else {
      httpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json');
    }
    return this.http.get(this.baseUrl + 'user/GetUserLocation/' + id, {headers: httpHeaders});
  }

  removeUserLocation(model: any) {
    return this.http.post(this.baseUrl + 'user/RemoveUserLocation', model, {observe: 'response'});
  }

  updateUserLocations(userId: any, model: any) {
    let tokenString = '';
    const securityToken: string = localStorage.getItem('token');
    let httpHeaders = new HttpHeaders();
    if (securityToken != null) {
      tokenString = `Bearer ${securityToken}`;
      httpHeaders = new HttpHeaders()
        .set('authorization', tokenString)
        .set('Content-Type', 'application/json');
    } else {
      httpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json');
    }
    return this.http.put(this.baseUrl + `user/UpdateLocations/` + userId, model,
    {headers: httpHeaders, responseType: 'blob' as 'json', observe: 'response' });
  }
}
